import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        token: '',
        account: {},
        role: '',
        //host: 'http://localhost'

    },
    getters: {
        account(state) {
            return state.account
        }
    },
    mutations: {
        setToken(state, token) {
            state.token = token
        },
        setAccount(state, account) {
            state.account = account
        },
        setRole(state, role) {
            state.role = role
        }
    },
    actions: {

    }
})
